import styled from 'styled-components'
// icons
import CheckedOriginIcon from '@mui/icons-material/Check'
// utils
import { size } from 'polished'

const CheckedIcon = styled(CheckedOriginIcon)`
  position: absolute;
  right: 0;
  ${size('14px')};
`

const FieldWrapper = styled('div')`
  margin-right: 8px;
`

export { CheckedIcon, FieldWrapper }
